/** @jsxImportSource @emotion/react */
import { ConfigProvider } from "antd";
import moment from "moment";
import "moment/locale/zh-cn";
import React, { useState } from "react";
import { RawIntlProvider } from "react-intl";
import { LocaleService } from "src/services/LocaleService";
moment.locale("zh-cn");

export default React.memo(function AppWrapper(
  // eslint-disable-next-line @typescript-eslint/ban-types
  props: React.PropsWithChildren<{}>
) {
  const { children } = props;

  const localeService = new LocaleService();
  const [intl] = useState(localeService.intl);
  const [antdLocale] = useState(localeService.antdLocale);

  return (
    <RawIntlProvider value={intl}>
      <ConfigProvider locale={antdLocale}>{children}</ConfigProvider>
    </RawIntlProvider>
  );
});
